const updateAccountStatusMessage = (assetType, action) => {
  const msgDiv = document.querySelector('.my-account-status-message');
  if (!window.isAuthenticated || !msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === 'add') {
      msgDiv.innerHTML = `${assetType} has been added to your favorites.`;
    }
    if (action === 'remove') {
      msgDiv.innerHTML = `${assetType} has been removed from your favorites.`;
    }
  }, 100);
};

const updateSwatchCartStatusMessage = (action) => {
  const msgDiv = document.querySelector('.my-account-status-message');
  if (!msgDiv) {
    return;
  }
  // Clear existing message
  msgDiv.innerHTML = '';
  setTimeout(() => {
    if (action === 'add') {
      msgDiv.innerHTML = 'Swatch has been added to your swatch cart.';
    }
    if (action === 'remove') {
      msgDiv.innerHTML = 'Swatch has been removed from your swatch cart.';
    }
  }, 100);
};

export {
  updateAccountStatusMessage,
  updateSwatchCartStatusMessage,
};
